import {VEHICLE_SELECTED} from "../../../reducers/indexReducer";
import {LOCAL_STORAGE_VEHICLE} from "../../../consts";

export const vehicleSelected = (vehicle) => {
    localStorage.setItem(LOCAL_STORAGE_VEHICLE, JSON.stringify(vehicle));
    return {
        type: VEHICLE_SELECTED,
        payload: {vehicle}
    }
}